// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__21os3","label":"Section_label__5umaF","contentWrap":"Section_contentWrap__3AeXq","footer":"Section_footer__qK5N_","footerInner":"Section_footerInner__1e5P3"};